import { render, staticRenderFns } from "./preguntas.vue?vue&type=template&id=2713bf3f&scoped=true"
import script from "./preguntas.vue?vue&type=script&lang=js"
export * from "./preguntas.vue?vue&type=script&lang=js"
import style0 from "./preguntas.vue?vue&type=style&index=0&id=2713bf3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713bf3f",
  null
  
)

export default component.exports